import { faImage } from "@fortawesome/free-regular-svg-icons";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import AuthContext from "../../AuthContext";
import { IconButton } from "../../IconButton";
import Button from "../Button";
import { FileInput, RawFormInput } from "../FormElements";
import { GroupContainer } from "../GroupContainer";
import { OptionsEditProps, QuestionDefinition, QuestionProps } from "../QuestionAnswer";
import { isDevelopment } from "consumerhouse-shared";

export const ImageQuestionDefinition: QuestionDefinition<ImageQuestionProps> = {
    icon: faImage,
    defaultOptions: {
        url: "",
    },
    questionComponent: ImageQuestion,
    optionsEditComponent: ImageQuestionOptionsEdit,
};

interface ImageQuestionProps {
    url: string;
    description?: string;
}

function ImageQuestion(props: QuestionProps<ImageQuestionProps, any>) {
    return (
        <img
            style={{ borderRadius: "0.5em", margin: "0.8em 0 0 0", maxHeight: "800px", maxWidth: "100%" }}
            src={(isDevelopment ? "http://localhost:3001" : "") + props.question.optionsJson!.url}
        />
    );
}

function ImageQuestionOptionsEdit(props: OptionsEditProps<ImageQuestionProps>) {
    const { client } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    return (
        <GroupContainer title="Foto">
            <div style={{ display: "flex" }}>
                <RawFormInput style={{ flexGrow: 1, marginRight: "0.5em" }} value={props.options!.url} placeholder="URL naar foto" />
                <FileInput
                    loading={loading}
                    disabled={loading}
                    onFile={async (file) => {
                        setLoading(true);
                        let arr = new Uint8Array(await file.arrayBuffer());
                        let str = "";
                        for (let i = 0; i < arr.byteLength; i++) {
                            str += String.fromCharCode(arr[i]);
                        }
                        try {
                            let res = await client.fetch("/file/upload", { data: btoa(str), name: file.name });
                            props.onChange({ ...props.options, url: res.url });
                        } catch (ex) {
                            console.error("could not upload file", ex);
                            alert("Kon bestand niet uploaden: " + (ex as Error).message);
                        } finally {
                            setLoading(false);
                        }
                    }}>
                    Foto uploaden
                </FileInput>
            </div>
            {props.options!.url && (
                <img
                    style={{ borderRadius: "0.5em", margin: "0.8em 0 0 0", maxHeight: "500px" }}
                    src={(isDevelopment ? "http://localhost:3001" : "") + props.options!.url}
                />
            )}
        </GroupContainer>
    );
}
